const signUpConfig = {
  allowLogin: true,
  allowSignUp: true,
  redirectUri: window.location.origin,
  initialScreen: 'signUp'
};

export default signUpConfig;